import React, { useCallback } from 'react';
import * as Styles from './ProjectsBar.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { IconMagicPen } from '../Icons/IconMagicPen';
import { IconFolder } from '../Icons/IconFolder';
import { IconAiFavorite } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import ButtonCreateSiteAi from '../HighlightFeatures/ButtonCreateSiteAi/ButtonCreateSiteAi';
import { useStudio } from '@/hooks/studio';
import { studioAnalytics } from '@/analytics/studio';
import { CONTENT_TABS } from '../../studio.enum';

const ProjectsBar = ({
  pickedTab, handleSetPickedTab, isProPlan, disableForMeOption,
}) => {
  const { studio: studioLocale } = useLocale();
  const { openStudio } = useStudio();

  const handleProjectsClick = useCallback(() => {
    studioAnalytics.projectsClick();
    openStudio('documents_history');
  }, [openStudio]);

  if (isProPlan) {
    return null;
  }

  return (
    <Styles.Wrapper data-testid="projects-bar">
      <Styles.Button
        data-testid={`manage-${CONTENT_TABS.FOR_YOU}-button`}
        active={pickedTab === CONTENT_TABS.FOR_YOU}
        onClick={() => handleSetPickedTab(CONTENT_TABS.FOR_YOU)}
        disabled={disableForMeOption}
      >
        <IconAiFavorite />
        {studioLocale.topBanner.forYou}
      </Styles.Button>

      <Styles.Button
        data-testid={`manage-${CONTENT_TABS.DESIGN}-button`}
        active={pickedTab === CONTENT_TABS.DESIGN}
        onClick={() => handleSetPickedTab(CONTENT_TABS.DESIGN)}
      >
        <IconMagicPen />
        {studioLocale.topBanner.design}
      </Styles.Button>

      <Styles.Button
        data-testid={`manage-${CONTENT_TABS.PROJECTS}-button`}
        onClick={() => handleProjectsClick()}
      >
        <IconFolder />
        {studioLocale.topBanner.projects}
      </Styles.Button>

      <ButtonCreateSiteAi position="bottom" />
    </Styles.Wrapper>
  );
};

export default withErrorBoundary(ProjectsBar, 'ProjectsBar');
